module.exports = __webpack_public_path__ + "img/348-d032a7.png";